export const formatDateValue = (
  value: string | number | null,
  type: "date" | "datetime"
) => {
  if (!value) return "N/A";

  const date = new Date(value);
  switch (type) {
    case "date":
      return `${("0" + (date.getUTCMonth() + 1)).slice(-2)}/${(
        "0" + date.getUTCDate()
      ).slice(-2)}/${date.getUTCFullYear()}`;
    case "datetime":
      return `${date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      })} ${date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`;
    default:
      return value;
  }
};

// PS-12031: cost center 485 (Fedex/Power) only runs orientation out of Sapulpa,
// so any other location picked for one of its drivers is a mistake. The rule is
// a warning, not a hard stop - recruiting still needs to be able to save an
// exception - so callers render the message rather than block submission.
export const ORIENTATION_LOCATION_RESTRICTIONS: {
  [costCenterNumber: string]: { fleet: string; locations: string[] };
} = {
  "485": { fleet: "Fedex/Power", locations: ["Sapulpa", "Sapulpa (Express)"] },
};

// Cost centers arrive as the cost-center list's `Name` string, and that column
// is not a bare number for every row ("485", "485 - Fedex Power", "Fedex Power
// (485)" are all shapes it takes), so match the number as its own digit run
// instead of comparing the whole string.
export const getOrientationLocationWarning = (
  costCenter?: string | null,
  orientationLocation?: string | null
) => {
  const restriction = ((costCenter ?? "").match(/\d+/g) ?? [])
    .map((number) => ORIENTATION_LOCATION_RESTRICTIONS[number])
    .find(Boolean);
  if (!restriction) return null;

  // An empty location is the required-field check's job, not this one's.
  const location = (orientationLocation ?? "").trim();
  if (!location || restriction.locations.includes(location)) return null;

  return `** ${restriction.fleet} drivers must select "${restriction.locations[0]}" for location`;
};
